<template>
	<SectionCard>
		<template #title>
			Banner Templates
		</template>
		<template #body>
			<v-row dense>
				<v-col cols="6">
					<div class="cassie-vertical-md">
						<Dropdown
							:value.sync="cookieBanner.cookieCollectionTemplateId"
							:disabled="!userCanCreateUpdate"
							:items="collectionTemplateItems"
							searchable
							label="Collection Template *"
							rules="required"
							@input="selectCollectionTemplate($event)"
						/>
						<div v-if="cookieBanner.cookieCollectionTemplateId && cookieCollectionDescription">
							{{ cookieCollectionDescription }}
						</div>
					</div>
				</v-col>
				<v-col
					v-if="userCanCreateUpdate && userCanCreateEditCookieCollectionTemplates"
					cols="6"
				>
					<TextButton
						@click="$emit('show-cookie-collection-manage-screen')"
					>
						<v-icon>
							mdi-plus
						</v-icon>
						Create
					</TextButton>
					<TextButton
						v-if="cookieBanner.cookieCollectionTemplateId"
						@click="$emit('open-edit-collection-template-screen', cookieBanner.cookieCollectionTemplateId)"
					>
						<v-icon class="mr-2">
							mdi-pencil
						</v-icon>
						Edit Selected Collection Template
					</TextButton>
				</v-col>
				<v-col
					v-else-if="userCanSeeCookieCollectionTemplates && cookieBanner.cookieCollectionTemplateId"
					cols="6"
				>
					<TextButton
						@click="$emit('open-edit-collection-template-screen', cookieBanner.cookieCollectionTemplateId)"
					>
						<v-icon>
							mdi-eye
						</v-icon>
						View Selected Collection Template
					</TextButton>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="6">
					<div class="cassie-vertical-md">
						<Dropdown
							:value.sync="cookieBanner.cookieTextTemplateId"
							:disabled="!userCanCreateUpdate || useTemplate"
							:items="textTemplateItems"
							searchable
							label="Text Template *"
							rules="required"
							@input="updateBanner('cookieTextTemplateId', $event)"
						/>
						<div v-if="cookieBanner.cookieTextTemplateId && cookieTextDescription">
							{{ cookieTextDescription }}
						</div>
					</div>
				</v-col>
				<v-col
					v-if="userCanCreateUpdate && userCanCreateEditCookieTextTemplates && !useTemplate"
					cols="6"
				>
					<TextButton
						@click="$emit('show-cookie-text-manage-screen')"
					>
						<v-icon>
							mdi-plus
						</v-icon>
						Create
					</TextButton>
					<TextButton
						v-if="cookieBanner.cookieTextTemplateId"
						@click="$emit('open-edit-text-template-screen', cookieBanner.cookieTextTemplateId)"
					>
						<v-icon>
							mdi-pencil
						</v-icon>
						Edit Selected Text Template
					</TextButton>
				</v-col>
				<v-col v-else-if="userCanSeeCookieTextTemplates && cookieBanner.cookieTextTemplateId">
					<TextButton
						@click="$emit('open-edit-text-template-screen', cookieBanner.cookieTextTemplateId)"
					>
						<v-icon>
							mdi-eye
						</v-icon>
						View Selected Text Template
					</TextButton>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="6">
					<div class="cassie-vertical-md">
						<Dropdown
							:value.sync="cookieBanner.cookieAppearanceTemplateId"
							:disabled="!userCanCreateUpdate || useTemplate"
							:items="appearanceTemplateItems"
							searchable
							label="Appearance Template *"
							rules="required"
							@input="updateBanner('cookieAppearanceTemplateId', $event)"
						/>
						<div v-if="cookieBanner.cookieAppearanceTemplateId && cookieAppearanceDescription">
							{{ cookieAppearanceDescription }}
						</div>
					</div>
				</v-col>
				<v-col
					v-if="userCanCreateUpdate && userCanCreateEditCookieAppearanceTemplates && !useTemplate"
					cols="6"
				>
					<TextButton

						@click="$emit('show-cookie-appearance-manage-screen')"
					>
						<v-icon>
							mdi-plus
						</v-icon>
						Create
					</TextButton>
					<TextButton
						v-if="cookieBanner.cookieAppearanceTemplateId"
						@click="$emit('open-edit-appearance-template-screen', cookieBanner.cookieAppearanceTemplateId)"
					>
						<v-icon>
							mdi-pencil
						</v-icon>
						Edit Selected Appearance Template
					</TextButton>
				</v-col>
				<v-col v-else-if="userCanSeeCookieAppearanceTemplates && cookieBanner.cookieAppearanceTemplateId">
					<TextButton
						@click="$emit('open-edit-appearance-template-screen', cookieBanner.cookieAppearanceTemplateId)"
					>
						<v-icon>
							mdi-eye
						</v-icon>
						View Selected Appearance Template
					</TextButton>
				</v-col>
			</v-row>
		</template>
	</SectionCard>
</template>
<script>
import { mapGetters } from 'vuex'
import SectionCard from '../../../../../../../shared/components/section-card.vue'
import Dropdown from '../../../../../../../shared/components/dropdown.vue'
import TextButton from '../../../../../../../shared/components/text-button.vue'
import { UNIVERSAL_BRAND } from '../../../../../../../shared/state/brands.js'
import {
	CAN_SEE_COOKIE_COLLECTION_TEMPLATES,
	COOKIE_COLLECTION_TEMPLATES_FULL_PERMISSIONS,
	CAN_SEE_COOKIE_APPEARANCE_TEMPLATES,
	COOKIE_APPEARANCE_TEMPLATES_FULL_PERMISSIONS,
	CAN_SEE_COOKIE_TEXT_TEMPLATES,
	COOKIE_TEXT_TEMPLATES_FULL_PERMISSIONS
} from '../../../../../../../shared/permissions/admin-portal-permissions.js'

export default {
	components: {
		SectionCard,
		Dropdown,
		TextButton
	},
	props: {
		cookieCollectionTemplates: {
			type: Array,
			default: () => []
		},
		cookieTextTemplates: {
			type: Array,
			default: () => []
		},
		cookieAppearanceTemplates: {
			type: Array,
			default: () => []
		},
		cookieBanner: Object,
		updateBanner: Function,
		isEdit: {
			type: Boolean,
			default: false
		},
		cloneMode: {
			type: Boolean,
			default: false
		},
		useTemplate: {
			type: Boolean,
			default: false
		},
		userCanCreateUpdate: Boolean
	},
	data () {
		return {
			selectedCookieScript: null,
			selectedCookieName: null
		}
	},
	computed: {
		...mapGetters('auth', ['productAreaPermission']),
		userCanSeeCookieCollectionTemplates () {
			return this.productAreaPermission(CAN_SEE_COOKIE_COLLECTION_TEMPLATES)
		},
		userCanCreateEditCookieCollectionTemplates () {
			return this.productAreaPermission(COOKIE_COLLECTION_TEMPLATES_FULL_PERMISSIONS)
		},
		userCanSeeCookieTextTemplates () {
			return this.productAreaPermission(CAN_SEE_COOKIE_TEXT_TEMPLATES)
		},
		userCanCreateEditCookieTextTemplates () {
			return this.productAreaPermission(COOKIE_TEXT_TEMPLATES_FULL_PERMISSIONS)
		},
		userCanSeeCookieAppearanceTemplates () {
			return this.productAreaPermission(CAN_SEE_COOKIE_APPEARANCE_TEMPLATES)
		},
		userCanCreateEditCookieAppearanceTemplates () {
			return this.productAreaPermission(COOKIE_APPEARANCE_TEMPLATES_FULL_PERMISSIONS)
		},
		collectionTemplateItems () {
			const collectionTemplateItems = this.cookieCollectionTemplates.map(({ name, id, brandId }) => ({
				text: name,
				value: id,
				brandId
			})).sort((a, b) => a.text.localeCompare(b.text))
			return this.cookieBanner.brandId === UNIVERSAL_BRAND
				? collectionTemplateItems
				: collectionTemplateItems.filter(({ brandId }) => brandId === UNIVERSAL_BRAND || brandId === this.cookieBanner.brandId)
		},
		textTemplateItems () {
			const textTemplateItems = this.cookieTextTemplates.map(({ name, id, brandId }) => ({
				text: name,
				value: id,
				brandId
			})).sort((a, b) => a.text.localeCompare(b.text))
			return this.cookieBanner.brandId === UNIVERSAL_BRAND
				? textTemplateItems
				: textTemplateItems.filter(({ brandId }) => brandId === UNIVERSAL_BRAND || brandId === this.cookieBanner.brandId)
		},
		appearanceTemplateItems () {
			const appearanceTemplateItems = this.cookieAppearanceTemplates.map(({ name, id, brandId }) => ({
				text: name,
				value: id,
				brandId
			})).sort((a, b) => a.text.localeCompare(b.text))
			return this.cookieBanner.brandId === UNIVERSAL_BRAND
				? appearanceTemplateItems
				: appearanceTemplateItems.filter(({ brandId }) => brandId === UNIVERSAL_BRAND || brandId === this.cookieBanner.brandId)
		},
		cookieCollectionDescription () {
			return this.cookieCollectionTemplates.find(({ id }) => id === this.cookieBanner.cookieCollectionTemplateId)?.description
		},
		cookieTextDescription () {
			return this.cookieTextTemplates.find(({ id }) => id === this.cookieBanner.cookieTextTemplateId)?.description
		},
		cookieAppearanceDescription () {
			return this.cookieAppearanceTemplates.find(({ id }) => id === this.cookieBanner.cookieAppearanceTemplateId)?.description
		},
		templatesCardTitle () {
			return !this.cookieBanner.enableCis ? 'Banner Templates' : 'Text and Appearance Template'
		}
	},
	methods: {
		async selectCollectionTemplate (collectionTemplateId) {
			await this.updateBanner('cookieCollectionTemplateId', collectionTemplateId)
			const collectionTemplate = this.cookieCollectionTemplates.find(({ id }) => id === collectionTemplateId)
			await this.updateBanner('enableCis', collectionTemplate.crossDomainConsent)
			await this.updateBanner('allowedDomainsValue', !collectionTemplate.crossDomainConsent)
		}
	}
}
</script>
